import * as Sentry from "@sentry/react";

const SENTRY_DSN = "https://4027b1c430fd13b0d6e3d78031b591a7@o4512017625186304.ingest.us.sentry.io/4512265851830272";

export function monitoringEnabled(env: ImportMetaEnv = import.meta.env) {
  return (env.PROD || env.VITE_APP_ENV === "staging") && env.MODE !== "test" && env.VITE_SENTRY_ENABLED !== "false";
}

export function initializeMonitoring(env: ImportMetaEnv = import.meta.env) {
  if (!monitoringEnabled(env)) return false;
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: env.VITE_APP_ENV || env.MODE,
    release: env.VITE_APP_RELEASE || __APP_RELEASE__,
    beforeSend(event) {
      delete event.user;
      delete event.request;
      delete event.breadcrumbs;
      delete event.message;
      delete event.transaction;
      delete event.fingerprint;
      if (event.extra) event.extra = {};
      if (event.contexts) event.contexts = {};
      if (event.exception?.values) event.exception.values = event.exception.values.map((value) => ({ ...value, value: value.type || "Application error" }));
      return event;
    },
  });
  return true;
}

export { Sentry };
